import { render, staticRenderFns } from "./OrgQueues.vue?vue&type=template&id=51867178"
import script from "./OrgQueues.vue?vue&type=script&lang=js"
export * from "./OrgQueues.vue?vue&type=script&lang=js"
import style0 from "./OrgQueues.vue?vue&type=style&index=0&id=51867178&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports